import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import fetchNewspapersData from '../store/newspapers/actions/fetchNewspapersData';
import { newspapersStateSelector } from '../store/newspapers/newspapersSelectors';
import fetchNewspapersByMonthAndPublicationThunk from '../store/newspapers/actions/fetchNewspapersByMonthAndPublication';
export var useNewspapersActionsDispatches = function () {
    var dispatch = useDispatch();
    var fetchNewspapers = useCallback(function (date) { return dispatch(fetchNewspapersData(date)); }, [dispatch, fetchNewspapersData]);
    var fetchNewspapersByMonthAndPublication = useCallback(function (date, publication) { return dispatch(fetchNewspapersByMonthAndPublicationThunk(date, publication)); }, [dispatch, fetchNewspapersData]);
    return { fetchNewspapers: fetchNewspapers, fetchNewspapersByMonthAndPublication: fetchNewspapersByMonthAndPublication };
};
/**
 * A custom hook that, by default, returns the relevant information of the "newspapers" state
 * using the `newspapersStateSelector` and its related actions.
 * It is possible to override the selection by providing a custom selector.
 */
var useNewspapers = function (selector) {
    if (selector === void 0) { selector = newspapersStateSelector; }
    var state = useSelector(selector);
    var actions = useNewspapersActionsDispatches();
    return [state, actions];
};
export default useNewspapers;
